import React, { useCallback, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import { Alert } from '@mui/material';
import { ADMIN_USERS_QUERY } from '../../gql';
import { Main } from '../../components';
import { AdminUsersTable } from './AdminUsersTable';
import { AdminUserRow } from './types';
import { FormattedMessage } from 'react-intl';

export const AdminUsers = React.memo(() => {
  const [mutationError, setMutationError] = useState<string | null>(null);
  const { data, error, loading } = useQuery(ADMIN_USERS_QUERY, {
    fetchPolicy: 'cache-and-network',
  });
  const rows = useMemo<AdminUserRow[]>(() => data?.adminUsers || [], [
    data?.adminUsers,
  ]);
  const handleMutationError = useCallback((message: string) => {
    setMutationError(message);
  }, []);

  return (
    <Main>
      {error ? (
        <Alert severity="error">
          <FormattedMessage
            id="admin.users.loadError"
            defaultMessage="Unable to load users."
          />
        </Alert>
      ) : null}
      {mutationError ? <Alert severity="error">{mutationError}</Alert> : null}
      <AdminUsersTable
        loading={loading}
        onError={handleMutationError}
        rows={rows}
      />
    </Main>
  );
});
